module.exports = __webpack_public_path__ + "static/media/icsa-portrait.8a7cb6f6.svg";